import Vue from 'vue'

//封装指令 只能输入数字
function onInput(el, ele, binding, vnode) {
  function handle() {
    // 只保留数字
    // let reg = new RegExp("^\\d*$");
    // if(ele.value && !reg.test(ele.value)){

    if (ele.val !== '' && typeof binding.value === 'object') {
      ele.value = ele.value.replace(/[^\d]/g, '')
      let {
        maxlength
      } = binding.value
      if (binding.value.maxlength) {
        ele.value = ele.value.replace(new RegExp('^(\\d{' + (binding.value.maxlength - 1) + '})\\.$'), '$1')
      }
    } else {
      ele.value = ele.value.replace(/[^\d]/g, '')
    }
    // ele.value = ele.value.replace(/^[0]+[^\.]*/g, '0')
    if (vnode.componentInstance) {
      vnode.componentInstance.$emit('input', ele.value)
    } else {
      vnode.elm.dispatchEvent(new CustomEvent('input', ele.value))
    }
    // }
  }

  return handle
}

const numberInput = {
  bind(el, binding, vnode) {
    const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
    ele.addEventListener('input', onInput(el, ele, binding, vnode), false)
  },
}
Vue.directive('number-input', numberInput)
/* 
封装指令 只能输入带小数位数的数字
params
{ min: 0, decimal: 2, preDecimal: 5 }
min最小值
preDecimal  小数点前位数
maxlength 输入最大输入长度数字后不能输入小数点
max最大值
*/
function onInputFloat(el, ele, binding, vnode) {
  function handle() {
    let val = ele.value
    // modifiers为修饰符对象，传入了float，则其float属性为true
    if (binding.modifiers.float) {
      // 清除"数字"和"."以及"-"以外的字符
      val = val.replace(/[^\-\d.]/g, '')
      // 只保留第一个'-'号
      val = val.replace(/\.{2,}/g, '.').replace(/\-{2,}/g, '-')
      // 将 '多余的0' 替换成 '0'
      val = val.replace(/^[0]+[^\.]*/g, '0')
      // 将 '-.' 替换成 '-0.'
      val = val.replace(/^\./g, '0.').replace(/^\-\./, '-0.')
      if (typeof binding.value !== 'undefined') {
        // 期望保留的最大小数位数
        let pointKeep = 0
        if (typeof binding.value === 'string' || typeof binding.value === 'number') {
          pointKeep = parseInt(binding.value)
        } else if (typeof binding.value === 'object') {
          // 支持新的小数点保留位配置
          pointKeep = binding.value.decimal
        }
        if (!isNaN(pointKeep)) {
          if (!Number.isInteger(pointKeep) || pointKeep < 0) {
            pointKeep = 0
          }
          // 增加'-'号的支持
          const str = '^(\\-)*(\\d+)\\.(\\d{0,' + pointKeep + '}).*$'
          const reg = new RegExp(str)
          if (pointKeep === 0) {
            // 不需要小数点
            val = val.replace(reg, '$1$2')
          } else {
            // 通过正则保留小数点后指定的位数
            val = val.replace(reg, '$1$2.$3')
          }
          //输入最大输入长度数字后不能输入小数点
          if (binding.value.maxlength) {
            val = val.replace(new RegExp('^(\\-)*(\\d{' + (binding.value.maxlength - 1) + '})\\.$'), '$1$2')
          }
          //  小数点前位数
          if (binding.value.preDecimal) {
            val = val.replace(new RegExp('^(\\-)*(\\d{' + binding.value.preDecimal + '})\\d*$'), '$1$2')
          }
        }
      } else {
        let pointKeep = 2
        if (typeof binding.value === 'string' || typeof binding.value === 'number') {
          pointKeep = parseInt(binding.value)
        } else if (typeof binding.value === 'object') {
          // 支持新的小数点保留位配置
          pointKeep = binding.value.decimal
        }
        if (!isNaN(pointKeep)) {
          if (!Number.isInteger(pointKeep) || pointKeep < 0) {
            pointKeep = 0
          }
          // 增加'-'号的支持
          const str = '^(\\-)*(\\d+)\\.(\\d{0,' + pointKeep + '}).*$'
          const reg = new RegExp(str)
          if (pointKeep === 0) {
            // 不需要小数点
            val = val.replace(reg, '$1$2')
          } else {
            // 通过正则保留小数点后指定的位数
            val = val.replace(reg, '$1$2.$3')
          }
        }
      }
      if (val !== '' && typeof binding.value === 'object') {
        let {
          min,
          max
        } = binding.value
        min = parseFloat(min)
        max = parseFloat(max)
        if (!isNaN(min)) {
          if (min >= 0) {
            // 不能是负数
            val = val.replace('-', '')
          }
          if (parseFloat(val) < min) {
            val = min
          }
        }
        if (!isNaN(max)) {
          if (parseFloat(val) > max) {
            val = max
          }
        }
      }
      ele.value = val
      if (vnode.componentInstance) {
        vnode.componentInstance.$emit('input', ele.value)
      } else {
        vnode.elm.dispatchEvent(new CustomEvent('input', ele.value))
      }
    }
  }

  return handle
}

const floatInput = {
  bind(el, binding, vnode) {
    const ele = el.tagName === 'INPUT' ? el : el.querySelector('input');
    ele.addEventListener('input', onInputFloat(el, ele, binding, vnode), false);
    ele.addEventListener('blur', function () {
      let val = ele.value.replace(/\.$/, '')
      if (vnode.componentInstance) {
        vnode.componentInstance.$emit('input', val)
      } else {
        vnode.elm.dispatchEvent(new CustomEvent('input', val))
      }
    }, false)
  },
}
Vue.directive('float-input', floatInput);



//封装指令 只能输入整数
function onInputInt(el, ele, binding, vnode) {
  function handle() {
    let newStr = ""
    if (ele.value[0] === '-') {
      newStr += '-'
    }
    for (let strKey in ele.value) {
      if (ele.value[strKey].match(/[0-9]/g)) {
        newStr += ele.value[strKey]
      }
    }
    ele.value = newStr
    if (vnode.componentInstance) {
      vnode.componentInstance.$emit('input', ele.value)
    } else {
      vnode.elm.dispatchEvent(new CustomEvent('input', ele.value))
    }
  }
  return handle
}

const intInput = {
  bind(el, binding, vnode) {
    const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
    ele.addEventListener('input', onInputInt(el, ele, binding, vnode), false)
  },
}
Vue.directive('int-input', intInput);


//封装指令 可输入非汉字字符
function onInputNoChinese(el, ele, binding, vnode) {
  function handle() {
    let newStr = ""
    for (let strKey in ele.value) {
      if (ele.value[strKey].match(/[^\u4e00-\u9fa5]/g)) {
        newStr += ele.value[strKey]
      }
    }
    ele.value = newStr
    if (vnode.componentInstance) {
      vnode.componentInstance.$emit('input', ele.value)
    } else {
      vnode.elm.dispatchEvent(new CustomEvent('input', ele.value))
    }

 }
  return handle
}

const noChineseInput = {
  bind(el, binding, vnode) {
    const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
    ele.addEventListener('input', onInputNoChinese(el, ele, binding, vnode), false)
  },
}
Vue.directive('no-chinese-input', noChineseInput);
